import React from "react";

export default function Header(props) {
  return (
    <div className={props.className}>
      <h2>Project By: Omkar Bargaje</h2>
    </div>
  );
}
